/**
 * Исполнение platform/client скриптов в non-strict режиме (Swing/Rhino parity).
 *
 * Direct `eval` из ESM-модуля всегда strict → `pdPolicy = 0` без var бросает ReferenceError.
 * `new Function` / AsyncFunction по умолчанию non-strict: необъявленное присвоение создаёт
 * binding на globalThis, как в Rhino.
 */
type AsyncFunctionConstructor = new (...args: string[]) => (...args: unknown[]) => Promise<unknown>

let cachedAsyncFunction: AsyncFunctionConstructor | null = null

function getAsyncFunctionConstructor(): AsyncFunctionConstructor {
  if (!cachedAsyncFunction) {
    cachedAsyncFunction = Object.getPrototypeOf(async function () {}).constructor as AsyncFunctionConstructor
  }
  return cachedAsyncFunction
}

export async function evaluatePlatformScript(
  code: string,
  options?: { async?: boolean },
): Promise<unknown> {
  if (options?.async) {
    const AsyncFunction = getAsyncFunctionConstructor()
    const fn = new AsyncFunction(code)
    return await fn()
  }
  const fn = new Function(code)
  return fn()
}
